import { devDebug } from "../lib/devLog";
// SEC-001 migration: on authenticated load, if the server-side profile
// for the current user does not yet include a valid Ed25519 signature
// binding the DM key to the identity, re-upsert the profile so the
// binding is populated. Runs once per session — no-op afterwards.
//
// This is also the bootstrap path for legacy users who have a valid local
// identity but no server-side profile row yet.

import { useEffect, useRef } from "react";
import axios from "axios";
import { loadIdentity } from "../lib/identity";
import { upsertProfile } from "../lib/postsApi";

const API = process.env.REACT_APP_BACKEND_URL || "";

export function useAutoSignDmKey(user) {
  const doneRef = useRef(false);
  useEffect(() => {
    if (doneRef.current) return;
    if (!user?.identityId) return;
    const identity = loadIdentity();
    if (!identity) return;
    doneRef.current = true;
    (async () => {
      try {
        let profile = null;
        try {
          const r = await axios.get(
            `${API}/api/v1/profiles/${encodeURIComponent(user.identityId)}`,
            { timeout: 8000 },
          );
          profile = r.data?.profile || null;
        } catch (error) {
          // A 404 is not a migration failure: it means this is a legacy local
          // identity that still needs its first server-side profile bootstrap.
          if (error?.response?.status !== 404) throw error;
        }

        if (profile?.x25519PublicKeyHex && profile?.x25519SignatureHex) return;
        await upsertProfile({
          displayName: identity.name || user.displayName || "Utente",
          avatar: identity.avatar || user.avatar || "",
        });
      } catch (err) {
        // Migration is best-effort. Diffondi also retries the same bootstrap
        // synchronously, so a transient startup failure does not block the user.
        devDebug("useAutoSignDmKey migration skipped", err?.message);
      }
    })();
  }, [user]);
}
